/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MeCreate = {
    properties: {
        billingAccountId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        operatorId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        username: {
            type: 'string',
            isRequired: true,
            maxLength: 320,
            minLength: 3,
        },
        name: {
            type: 'string',
            isRequired: true,
            maxLength: 100,
        },
        phoneNumber: {
            type: 'string',
            isNullable: true,
        },
        password: {
            type: 'string',
            isNullable: true,
        },
        confirmPassword: {
            type: 'string',
            isNullable: true,
        },
    },
};